const getInitials = (firstName = '', lastName = '', email = '') => {
  const initials = `${(firstName && firstName[0]) || ''}${(lastName
    && lastName[0])
    || ''}`;
  return initials || email[0];
};

export default getInitials;
